import PropType from 'prop-types';
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import '../App.css';
import { Settings } from '../commons/constants';
import { FORM_STATE, useForm } from '../commons/form';
import { useDomainName } from '../commons/hooks';
import { Button } from './Button';
import { FormFeedback } from './FormFeeback';
import { TextInput } from './TextInput';

const FormSuccess = () => {
  const domainName = useDomainName();
  return (
    <>
      <div className='card-title'>
        <span>Your message has been sent to the owner(s) of this domain.</span>
      </div>
      <div className='card-block'>
        <p className='center'>
          Thank you for submitting an inquiry. &#8212; <strong>{domainName}</strong>
        </p>
      </div>
    </>
  );
};

const Contact = ({ form }) => {
  return (
    <>
      <div className='card-title'>
        <span>Contact the Domain Owner</span>
      </div>
      <div className='card-block'>
        <div className='form-fields'>
          <TextInput required {...form.fields.name} />
          <div className='row'>
            <TextInput required {...form.fields.email} />
            <TextInput required {...form.fields.phone} />
          </div>
          <TextInput {...form.fields.comments} />
        </div>
        <ReCAPTCHA sitekey={Settings.RECPATCHA_SITE_KEY} onChange={form.fields.recaptcha.handleChange} />
        <FormFeedback validationMessages={form.validationMessages} />
        <Button text='Send Message' onClick={form.submit} />
      </div>
    </>
  );
};

Contact.propTypes = {
  form: PropType.shape({
    fields: PropType.object,
    validationMessages: PropType.arrayOf(PropType.string),
    submit: PropType.func
  })
};

export const ContactForm = () => {
  const form = useForm();
  return form.formState === FORM_STATE.SUCCESS ? <FormSuccess /> : <Contact form={form} />;
};
